import { Container } from '@global-engineering-shared/gweb-material-ui';
import { useEffect } from 'react';

import TableContainer from 'components/EntityListTable/components/TableContainer';
import TablePageHeader from 'components/TablePageHeader';
import { useFilters } from 'context/FilterProvider/FilterProvider';
import OverrideUploadInProgressCard from 'features/Drafts/components/OverrideUploadInProgressCard';
import { draftsFilterValues, useDraftsTables } from 'features/Drafts/utils';
import { FilterType } from 'features/Filters/types/Filters';

const DraftsPage = () => {
  const { setCurrentFiltersPage } = useFilters();
  useEffect(() => {
    setCurrentFiltersPage(FilterType.DRAFTS);
  }, []);

  const tablesConfig = useDraftsTables();

  return (
    <main>
      <Container maxWidth="lg">
        <TableContainer
          tablesConfig={tablesConfig}
          tableHeader={
            <TablePageHeader title={'Drafts'} filterValues={draftsFilterValues}>
              <OverrideUploadInProgressCard />
            </TablePageHeader>
          }
        />
      </Container>
    </main>
  );
};

export default DraftsPage;
